import styled from "styled-components"

export const NavModuleStyles = styled.nav`
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    padding: 20px var(--borderSpacing) 0 var(--borderSpacing);

    @media (min-width: 1024px) {
      padding-top: 50px;
    }

    @media (min-width: 1440px) {
      padding-top: 70px;
    }
  }

  .hamburger {
    background-color: transparent;
    border: none;
    width: 30px;
    height: 30px;
    padding: 0;
    cursor: pointer;
    outline: none;

    &:focus {
      border: none;
      outline: none;
    }

    .bar {
      display: block;
      background-color: #fff;
      height: 2px;
      border-radius: 2px;

      &:nth-of-type(2) {
        margin-top: 8px;
        margin-bottom: 8px;
      }
    }
  }

  .logo {
    font-weight: 700;
    font-size: 20px;
    letter-spacing: -0.5px;

    a {
      color: #fff;
      text-decoration: none;
      transition: color 0.3s ease;
    }

    @media (min-width: 1024px) {
      font-size: 25px;
    }

    span {
      color: var(--primary);
    }

    &:hover,
    &:focus {
      a {
        color: var(--primary);
        text-shadow: 0 0 6px #66666660;
      }
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .menu {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin:auto;background:%23ffffff00;display:block;z-index:1;position:relative' width='1440' height='797' preserveAspectRatio='xMidYMid' viewBox='0 0 1440 797'%3E%3Cg transform='translate(720,398.5) scale(1,1) translate(-720,-398.5)'%3E%3Cg transform='translate(1118.2381262373478,89.59484495889996) scale(100)' opacity='0.4'%3E%3Cpath d='M4.661999999999999 0 C4.661999999999999 1.1591999999999998 5.38440735668038 1.3063789868664455 4.881449326295306 2.3507820985389296 S3.8130085107423555 2.9221489929513105 2.9067094562654154 3.6448983712659544 S2.3357548559764814 5.0242131615589605 1.2056184201753115 5.28215942820112 S0.09274384169683247 4.80306019323382 -1.0373925941043372 4.545113926591661 S-2.4717686919936774 4.958712350326429 -3.3780677464706175 4.2359629720117855 S-3.697358831776003 3.06716910343854 -4.200316862161077 2.022765991766056 S-5.417999999999999 1.1592000000000005 -5.417999999999999 6.635136357780359e-16 S-4.703274892546151 -0.9783628800935711 -4.200316862161078 -2.022765991766055 S-4.284366800947558 -3.5132135936971407 -3.378067746470619 -4.235962972011785 S-2.1675290299055083 -4.287167659949501 -1.0373925941043385 -4.545113926591661 S0.07548198437414078 -5.540105694843279 1.2056184201753104 -5.28215942820112 S2.0004104017884745 -4.367647749580598 2.9067094562654145 -3.644898371265955 S4.378491295910232 -3.395185210211415 4.881449326295305 -2.350782098538931 S4.661999999999999 -1.159200000000001 4.661999999999999 -1.141860675524992e-15' fill='%23ff4000' stroke-width='0'%3E%3CanimateTransform attributeName='transform' type='rotate' dur='50s' repeatCount='indefinite' values='0;51.42857142857143'%3E%3C/animateTransform%3E%3C/path%3E%3C/g%3E%3Cg transform='translate(1197.8857514848175,27.8138139506799) scale(100)' opacity='0.4'%3E%3Cpath d='M5.594399999999999 0 C5.594399999999999 1.3910399999999996 6.461288828016455 1.5676547842397346 5.8577391915543675 2.8209385182467153 S4.575610212890827 3.506578791541573 3.488051347518499 4.373878045519145 S2.8029058271717773 6.029055793870752 1.4467421042103739 6.338591313841343 S0.11129261003619884 5.763672231880585 -1.2448711129252048 5.454136711909993 S-2.9661224303924127 5.950454820391715 -4.053681295764741 5.083155566414143 S-4.436830598131204 3.6806029241262483 -5.040380234593292 2.4273191901192677 S-6.501599999999999 1.3910400000000005 -6.501599999999999 7.962163629336431e-16 S-5.643929871055381 -1.1740354561122857 -5.040380234593293 -2.4273191901192663 S-5.141240161137071 -4.215856312436569 -4.053681295764743 -5.083155566414141 S-2.60103483588661 -5.144601191939402 -1.2448711129252061 -5.454136711909993 S0.09057838124896866 -6.648126833811935 1.4467421042103723 -6.338591313841343 S2.4004924821461695 -5.2411772994967185 3.4880513475184975 -4.373878045519146 S5.254189555092278 -4.074222252253698 5.857739191554367 -2.820938518246717 S5.594399999999999 -1.391040000000001 5.594399999999999 -1.3702328106299905e-15' fill='%23ff4000' stroke-width='0'%3E%3CanimateTransform attributeName='transform' type='rotate' dur='25s' repeatCount='indefinite' values='0;51.42857142857143'%3E%3C/animateTransform%3E%3C/path%3E%3C/g%3E%3Cg transform='translate(1389.0400520787446,-120.4606604690481) scale(100)' opacity='0.4'%3E%3Cpath d='M7.832159999999999 0 C7.832159999999999 1.9474559999999994 9.045804359223037 2.194716697935628 8.200834868176115 3.9493139255454013 S6.405854298047157 4.909210308158202 4.883271886525899 6.123429263726804 S3.9240681580404884 8.440678111419052 2.0254389458945234 8.87402783937788 S0.15580965405067815 8.069141124632818 -1.7428195580952868 7.635791396673991 S-4.152571402549379 8.3306367485484 -5.6751538140706375 7.116417792979799 S-6.211562837383687 5.152844093776747 -7.05653232843061 3.3982468661669745 S-9.102239999999998 1.9474560000000005 -9.102239999999998 1.1147029081071003e-15 S-7.9015018194775335 -1.6436496385571997 -7.0565323284306105 -3.3982468661669727 S-7.197736225591898 -5.902198837411196 -5.675153814070639 -7.116417792979798 S-3.6414487702412535 -7.202441668715163 -1.7428195580952888 -7.635791396673991 S0.1268097337485563 -9.307377567336708 2.0254389458945212 -8.87402783937788 S3.3606894750046377 -7.337648219295406 4.883271886525897 -6.123429263726805 S7.35586537712919 -5.703911153155176 8.200834868176113 -3.9493139255454035 S7.832159999999998 -1.9474560000000014 7.832159999999999 -1.9183259348819865e-15' fill='%23ff4000' stroke-width='0'%3E%3CanimateTransform attributeName='transform' type='rotate' dur='16.666666666666668s' repeatCount='indefinite' values='0;51.42857142857143'%3E%3C/animateTransform%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 100%;
    width: var(--menuWidth);
    transform: translateX(calc(var(--menuWidth) * -1));
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 99;
    padding: 30px var(--borderSpacing);
    display: flex;
    align-items: center;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    li {
      text-transform: capitalize;
      letter-spacing: -0.5px;
      font-size: 28px;

      @media (min-width: 375px) {
        font-size: 36px;
      }

      @media (min-width: 414px) {
        font-size: 40px;
      }

      a {
        color: #fff;
        font-weight: 700;
        text-decoration: none;
      }

      span {
        color: var(--primary);
      }
    }
  }
`
